<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none smallinputs">

            <div class="availtable datatable text-left nested">
                <b-card-body class="py-0">
                    <b-row>
                        <b-col>
                            <table class="w-100pct mt-2">
                                     <tr class="mb-1 h6 ">
                                    <td class="w-30px pt-5px"> <span class="small text-primary"></span></td>
                                    <td class="w-30px pt-5px" colspan="3"><h5>Ticketing Script Simulator</h5> 
                                    </td>
                                   
                                    <td>
                                        <div class="text-right"></div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                      
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right"></div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                      Type search criteria or leave empty, then click FETCH to return values
                                    </td>
                                    <td class="h-22px"> </td>
                                </tr>
                                <tr class="mb-1 h6 ">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">1.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">Client</td>
                                    <td class="text-primary">A/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group>
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="A"
                                                    :disabled="!A_fetched" :clearable="true" :multiple="false"
                                                    :options="options_A" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_A" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_A = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('A/', fuzzy_A, 'options_A')">
                                            FETCH
                                        </b-button></td>
                                </tr>
                                <tr class="mb-1 h6">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">2.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">Event</td>
                                    <td class="text-primary">E/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="E"
                                                    :disabled="!E_fetched" :clearable="true" :multiple="false"
                                                    :options="options_E" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_E" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_E = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('E/', fuzzy_E, 'options_E')">
                                            FETCH
                                        </b-button></td>
                                </tr>
                                <tr class="mb-1 h6">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">3.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">Booker name</td>
                                    <td class="text-primary">BN/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="BN"
                                                    :disabled="!BN_fetched" :clearable="true" :multiple="false"
                                                    :options="options_BN" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_BN" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_BN = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('BN/', fuzzy_BN, 'options_BN')">
                                            FETCH
                                        </b-button></td>
                                </tr>
                                <tr class="mb-1 h6">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">4.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">Agent</td>
                                    <td class="text-primary">C/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="C"
                                                    :disabled="!C_fetched" :clearable="true" :multiple="false"
                                                    :options="options_C" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_C" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_C = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('C/', fuzzy_C, 'options_C')">
                                            FETCH
                                        </b-button></td>
                                </tr>
                                <tr class="mb-1 h6">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">5.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">EMD</td>
                                    <td class="text-primary">D/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="D"
                                                    :disabled="!D_fetched" :clearable="true" :multiple="false"
                                                    :options="options_D" :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_D" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_D = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('D/', fuzzy_D, 'options_D')">
                                            FETCH
                                        </b-button></td>
                                </tr>
                                <tr class="mb-1 h6">
                                    <td colspan="8"></td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm" variant="outline-primary"
                                            :disabled="false" @click="reset">
                                            RESET
                                        </b-button>
                                    </td>
                                </tr>

                                <!-- <tr class="mb-1 h6">
                                    <td class="w-30px pt-5px"> <span class="small text-primary">5.</span></td>
                                    <td class="w-30px pt-5px"> <i class="fa fa-code fa-1-5x text-purple"></i>
                                    </td>
                                    <td class="pl-1 w-150px strong">Fare Type</td>
                                    <td class="text-primary">FT/</td>
                                    <td>
                                        <div class="text-right">values:</div>
                                    </td>
                                    <td class="pt-3px w-300px pl-2">
                                        <b-form-group class="mb-3px">
                                            <b-input-group>
                                                <treeselect placeholder="Select..."
                                                    searchPromptText="Type at least 3 chars..." v-model="FT"
                                                    :clearable="true" :multiple="false" :options="options_FT"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                                                </treeselect>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <div class="text-right">fuzzy:</div>
                                    </td>
                                    <td class="pt-3px pl-2">
                                        <b-form-group class="courier">
                                            <b-input-group>
                                                <b-form-input size="sm" v-model="fuzzy_FT" placeholder="Fuzzy"
                                                    :formatter="onlyascii" trim></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="fuzzy_FT = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </td>
                                    <td class="h-22px"> <b-button class="mb-1 ml-1 btn-sm" size="sm"
                                            variant="outline-primary" :disabled="false"
                                            @click="load('FT/', fuzzy_FT, 'options_FT')">
                                            FETCH
                                        </b-button></td>
                                </tr> -->
                            </table>
                        </b-col>
                    </b-row>
                </b-card-body>

            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "MIFieldAPI",
    data() {
        return {
            busy: false,
            A: null,
            BN: null,
            C: null,
            D: null,
            E: null,
            FT: null,
            A_fetched: false,
            BN_fetched: false,
            C_fetched: false,
            D_fetched: false,
            E_fetched: false,
            FT_fetched: false,
            fuzzy_A: null,
            fuzzy_BN: null,
            fuzzy_C: null,
            fuzzy_D: null,
            fuzzy_E: null,
            fuzzy_FT: null,
            options_A: [],
            options_BN: [],
            options_C: [],
            options_D: [],
            options_E: [],
            options_FT: [],
        };
    },
    // watch: {
    //     A: {
    //         immediate: true,
    //         async handler(newVal, oldVal) {
    //             if (!newVal) {
    //                 await this.clear()
    //             }
    //         }
    //     }
    // },
    methods: {
        onlyascii(value) {
            // A SPECIFIC REPLACE
            value = value.split('b').join('')
            value = value.normalize('NFD').replace(/([\u0300-\u036f]|[^\x20-\x7E])/g, '')
            return value
        },
        async load(code, fuzzy, optionsname) {

            if (code == 'A/') {
                await this.clear()
            }
            let variables = {
                code,
                fuzzy,
                slac: this.A ? this.A : null
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_mifields($code: String, $fuzzy: String, $slac: String) {
                            setup_mifields(code: $code, fuzzy: $fuzzy, slac: $slac) {
                                id
                                label
                                rows
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.setup_mifields.length > 0) {
                    this[optionsname] = response.data.setup_mifields;
                }
            } catch (error) {
                console.log(error);
            }
            switch (code) {
                case 'A/':
                    this.A_fetched = true
                    break;
                case 'BN/':
                    this.BN_fetched = true
                    break;
                case 'C/':
                    this.C_fetched = true
                    break;
                case 'D/':
                    this.D_fetched = true
                    break;
                case 'E/':
                    this.E_fetched = true
                    break;
                case 'FT/':
                    this.FT_fetched = true
                    break;
            }
            this.busy = false;

        },
        async clear() {
            this.options_A = []
            this.options_BN = []
            this.options_C = []
            this.options_D = []
            this.options_E = []
            this.options_FT = []
        },
        async reset() {
            this.A = null
            this.BN = null
            this.C = null
            this.D = null
            this.E = null
            this.FT = null
            this.A_fetched = false
            this.BN_fetched = false
            this.C_fetched = false
            this.D_fetched = false
            this.E_fetched = false
            this.FT_fetched = false
            this.options_A = []
            this.options_BN = []
            this.options_C = []
            this.options_D = []
            this.options_E = []
            this.options_FT = []
            this.fuzzy_A = null
            this.fuzzy_BN = null
            this.fuzzy_C = null
            this.fuzzy_D = null
            this.fuzzy_E = null
            this.fuzzy_FT = null
        }
    },
};
</script>

<style></style>